export const OPEN_PRIVACY_NOTICE_MODAL = 'OPEN_PRIVACY_NOTICE_MODAL';
export const CLOSE_PRIVACY_NOTICE_MODAL = 'CLOSE_PRIVACY_NOTICE_MODAL';

function openPrivacyNoticeModal() {
  return {
    type: OPEN_PRIVACY_NOTICE_MODAL,
    isPrivacyNoticeModalShown: true
  };
}

function closePrivacyNoticeModal() {
  return {
    type: CLOSE_PRIVACY_NOTICE_MODAL,
    isPrivacyNoticeModalShown: false
  };
}

export function showPrivacyNoticeModal() {
  return (dispatch) => {
    dispatch(openPrivacyNoticeModal());
  };
}

export function hidePrivacyNoticeModal() {
  return (dispatch) => {
    dispatch(closePrivacyNoticeModal());
  };
}
